// types.ts
export interface NeedleData {
  srNo: number;
  curve: string;
  needleType: string;
  needleLength: number;
  boreDiameter: number;
  wireDiameter: number;
  coating: string;
}

export const needleRows: NeedleData[] = [
  {
    "srNo": 1,
    "curve": "Straight (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 60,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 2,
    "curve": "Straight (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 60,
    "boreDiameter": 39,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 3,
    "curve": "Straight (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 60,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 4,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 13,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 5,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 45,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 6,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 50,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 7,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 60,
    "boreDiameter": 25,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 8,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 9,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 50,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 10,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 55,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 11,
    "curve": "Straight (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 60,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 12,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 13,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 20,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 14,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 45,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 15,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 16,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 19,
    "boreDiameter": 25,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 17,
    "curve": "Straight (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 18,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 13,
    "boreDiameter": 25,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 19,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 16,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 20,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 19,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 21,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 19,
    "boreDiameter": 33,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 22,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 20,
    "boreDiameter": 35,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 23,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 20,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 24,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 25,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 35,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 26,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 18,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 27,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 46,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 28,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 12,
    "boreDiameter": 25,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 29,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 13,
    "boreDiameter": 22,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 30,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 15,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 31,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 15,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 32,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 16,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 33,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 19,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 34,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 35,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 16,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 36,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 19,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 37,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 38,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 16,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 39,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 18,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 40,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 19,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 41,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 19,
    "boreDiameter": 35,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 42,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 43,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 20,
    "boreDiameter": 28,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 44,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 26,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 45,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 46,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 47,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 48,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 36,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 49,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 40,
    "boreDiameter": 40,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 50,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 45,
    "boreDiameter": 37,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 51,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 45,
    "boreDiameter": 40,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 52,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 45,
    "boreDiameter": 42,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 53,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 54,
    "curve": "3/8 Circle (C)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 40,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 55,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 16,
    "boreDiameter": 25,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 56,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 57,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 58,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 25,
    "boreDiameter": 33,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 59,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 35,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 60,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 26,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 61,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 62,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 63,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 64,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 65,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 60,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 66,
    "curve": "3/8 Circle (C)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 67,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 16,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 68,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 69,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 18,
    "boreDiameter": 33,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 70,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 71,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 24,
    "boreDiameter": 33,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 72,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 26,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 73,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 40,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 74,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 22,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 75,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 37,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 76,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 35,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 77,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 78,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 36,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 79,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 80,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 81,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 82,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 83,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 84,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 45,
    "boreDiameter": 45,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 85,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 86,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 38,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 87,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 88,
    "curve": "3/8 Circle (C)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 89,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 16,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 90,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 20,
    "boreDiameter": 33,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 91,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 25,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 92,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 25,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 93,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 26,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 94,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 95,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 35,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 96,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 97,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 45,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 98,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 53,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 99,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 30,
    "boreDiameter": 59,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 100,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 35,
    "boreDiameter": 40,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 101,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 36,
    "boreDiameter": 33,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 102,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 36,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 103,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 36,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 104,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 36,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 105,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 37,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 106,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 107,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 108,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 109,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 110,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 111,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 40,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 112,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 45,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 113,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 45,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 114,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 45,
    "boreDiameter": 80,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 115,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 48,
    "boreDiameter": 83,
    "wireDiameter": 130,
    "coating": "Coated"
  },
  {
    "srNo": 116,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 117,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Cutting (K)",
    "needleLength": 50,
    "boreDiameter": 66,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 118,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 16,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 119,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 12,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 120,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 16,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 121,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 18,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 122,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 20,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 123,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 26,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 124,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 17,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 125,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 22,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 126,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 20,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 127,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 128,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 26,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 129,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 28,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 130,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 131,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 132,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 133,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 24,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 134,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 25,
    "boreDiameter": 45,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 135,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 136,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 37,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 137,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 30,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 138,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 36,
    "boreDiameter": 37,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 139,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 36,
    "boreDiameter": 42,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 140,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 36,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 141,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 142,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 40,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 143,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 45,
    "boreDiameter": 40,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 144,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 45,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 145,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 40,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 146,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 48,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 147,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 148,
    "curve": "1/2 Circle (A)",
    "needleType": "Reverse Cutting (X)",
    "needleLength": 48,
    "boreDiameter": 59,
    "wireDiameter": 130,
    "coating": "Coated"
  },
  {
    "srNo": 149,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 16,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 150,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 151,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 33,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 152,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 33,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 153,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 37,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 154,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 155,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 156,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 157,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 60,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 158,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 159,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 45,
    "boreDiameter": 53,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 160,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 161,
    "curve": "1/2 Circle (A)",
    "needleType": "Cutting (Y)",
    "needleLength": 50,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 162,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 16,
    "boreDiameter": 20,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 163,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 22,
    "boreDiameter": 28,
    "wireDiameter": 46,
    "coating": "Coated"
  },
  {
    "srNo": 164,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 16,
    "boreDiameter": 28,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 165,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 166,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 25,
    "boreDiameter": 25,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 167,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 31,
    "boreDiameter": 35,
    "wireDiameter": 54,
    "coating": "Coated"
  },
  {
    "srNo": 168,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 35,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 169,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 28,
    "wireDiameter": 60,
    "coating": "Coated"
  },
  {
    "srNo": 170,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 22,
    "boreDiameter": 35,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 171,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 26,
    "boreDiameter": 36,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 172,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 70,
    "coating": "Coated"
  },
  {
    "srNo": 173,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 20,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 174,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 26,
    "boreDiameter": 45,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 175,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 40,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 176,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 177,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 35,
    "boreDiameter": 42,
    "wireDiameter": 78,
    "coating": "Coated"
  },
  {
    "srNo": 178,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 51,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 179,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 36,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 180,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 42,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 181,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 182,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 45,
    "boreDiameter": 49,
    "wireDiameter": 84,
    "coating": "Coated"
  },
  {
    "srNo": 183,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 30,
    "boreDiameter": 68,
    "wireDiameter": 99,
    "coating": "Coated"
  },
  {
    "srNo": 184,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 36,
    "boreDiameter": 49,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 185,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 45,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 186,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 187,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 188,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 45,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 189,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 55,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 190,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 59,
    "wireDiameter": 100,
    "coating": "Coated"
  },
  {
    "srNo": 191,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 55,
    "wireDiameter": 110,
    "coating": "Coated"
  },
  {
    "srNo": 192,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 193,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 45,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 194,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 50,
    "boreDiameter": 65,
    "wireDiameter": 120,
    "coating": "Coated"
  },
  {
    "srNo": 195,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 40,
    "boreDiameter": 59,
    "wireDiameter": 130,
    "coating": "Coated"
  },
  {
    "srNo": 196,
    "curve": "1/2 Circle (A)",
    "needleType": "Taper Point (Z)",
    "needleLength": 55,
    "boreDiameter": 85,
    "wireDiameter": 130,
    "coating": "Coated"
  }
]